import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest } from '@/base/MaRequestPooler.js'

export function getMonthly({ type, trackId, countryCodes, startDate, endDate }, optionalParams) {
  return cacheRequest(`/market-estimation/${type}/${trackId}?countries=${countryCodes}&startDate=${startDate}&endDate=${endDate}&${paramsToQuery(optionalParams)}`)
}

export function getDaily({ type, trackId, countryCodes, startDate, endDate }, optionalParams) {
  return cacheRequest(`/market-estimation/${type}/${trackId}?countries=${countryCodes}&startDate=${startDate}&endDate=${endDate}&${paramsToQuery(optionalParams)}`)
}
